module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ben Weaver\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ben Weaver is a military scholar who spent years conceiving, researching, and writing "), _c('I', [_vm._v("Brothers In Arms.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oH0TXK/tc-custom/9780061749209.jpg?1737331095332",
      "alt": "This image is the cover for the book Patriots in Arms, Scott St. Andrew Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Patriots in Arms, Scott St. Andrew Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Scott St. Andrew has managed to escaped the hellish mining colony that was his homeworld, joining the Corps and fighting to save the Seventeen Worlds. Aided by an alien technology that makes him the best of the best—and simultaneously destroys him—Scott has dedicated his life to saving the free worlds. Now one of the enigmatic Wardens—a covert group that may hold the key to the saving the government—Major St. Andrew is sent back to the harsh moon where he trained, and to the alien caves that could save his life. But enemy forces and countermeasures make the mission unbelievably difficult, and divided loyalties hold the officer at a knife's edge. Scott has faced many tough decisions, but when a traitor's betrayal puts him into a POW camp, he faces the hardest choice of his life—save the woman he loves, or the world he's sworn to protect?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0